var autocompleteField = function(elementID,config){
  this.config = config;
  this.elementID = elementID;
  this.focusItem = -1;
  this.element = document.getElementById(elementID);
  this.load();

};

autocompleteField.prototype.load = function(){

  this.dropdownEl = document.createElement("ul");
  this.dropdownEl.classList.add("autocompleteField_dropdown");
  this.element.parentNode.style.position = "relative";
  this.element.parentNode.insertBefore(this.dropdownEl,this.element);
  this.element.setAttribute("autocomplete","falsewef");


  this.events();
}; 

autocompleteField.prototype.events = function(){
  var self = this;
  this.element.addEventListener("keyup",(e)=>{

    var val = e.currentTarget.value;
    if(val.length > 2 && !this.searched){
      this.searched = true;
      self.search(val);
    }
    else if(val.length <= 2){
      this.searched = false;
    }
    self.dropdown();
    if(val.length <= 2){
      self.dropdownEl.classList.remove("show");
    }

    var event = window.event ? window.event : e;
    this.keyEvents(e,event.keyCode);



  });



  this.element.addEventListener("keydown",(e)=>{
    if(e.keyCode == 13){
      e.preventDefault();
    }
  });


  var blurTimer = false;
  this.element.addEventListener("blur",(e)=>{
    if(blurTimer){
      clearTimeout(blurTimer);
    }
    blurTimer = setTimeout(function(){

      self.dropdownEl.classList.remove("show");
    },400);
  });
  this.element.addEventListener("focus",(e)=>{
    self.dropdown();
  });
};

autocompleteField.prototype.keyEvents = function(event,keyCode){
  if(keyCode == 40){
    this.focusItem++;
    this.updateFocus();
  }
  else if(keyCode == 38){
    --this.focusItem;
    this.updateFocus();
  }
  else if(keyCode == 13){
    var items = this.dropdownEl.querySelectorAll("li");
    if(items && items[this.focusItem]){
      this.itemClick(items[this.focusItem]);
    }
  }
  else{
    this.focusItem = -1;
  }




};

autocompleteField.prototype.updateFocus = function(){
    this.dropdownEl.querySelector("li.focus") && this.dropdownEl.querySelector("li.focus").classList.remove("focus");
    var items = this.dropdownEl.querySelectorAll("li");
    if(this.focusItem >= items.length){
      this.focusItem = items.length-1;
    }
    else if(this.focusItem < -1){
      this.focusItem = -1;
    }
    if(items[this.focusItem]){
      items[this.focusItem].classList.add("focus");

      items[this.focusItem].parentNode.scrollTop = items[this.focusItem].offsetTop - 50;

    }



}

autocompleteField.prototype.search = function(val){
  var self = this;
  if(this.searchTimer){
    clearTimeout(this.searchTimer);
  }
  this.searchTimer = setTimeout(()=>{
    fetch(this.config.url+val,{
      method:"GET",
      headers:{
        'Content-Type':'application/json',
        'Accept':'application/json'
      }
    }).then(res=>res.json())
    .then(data=>{
      self.data = data;
      self.dropdown();
    });
  },200);


};


autocompleteField.prototype.dropdown = function(){
  var self = this;

  var q = this.element.value.toLowerCase();
  if(this.data){
    this.filteredData = this.data.filter(d=>{
      if(d[this.config.dataKey].toLowerCase().indexOf(q) >= 0){
        return true;
      }
      return false;
    });

    this.filteredData = this.filteredData.map(d=>{
      var searchExp = new RegExp("("+q+")","i");
      d.query = d[this.config.dataKey].replace(searchExp,"<u>$1</u>");

      return d;
    });

  }


  if(this.filteredData && this.filteredData.length > 0){

    this.dropdownEl.classList.add("show");
    this.dropdownEl.innerHTML = "";
    for(let d of this.filteredData){
      var item = document.createElement("li");
      item.innerHTML = this.config.template(d);
      item.setAttribute("data-json",JSON.stringify(d));

      item.addEventListener("click",function(e){
        self.itemClick(e.currentTarget);
      });
      this.dropdownEl.append(item);
    }

  }
  else{
    this.dropdownEl.classList.remove("show");
  }

};

autocompleteField.prototype.itemClick = function(item){
  var itemIndex = item.getAttribute("data-index");
  var itemDetails = item.getAttribute("data-json");
  itemDetails = JSON.parse(itemDetails);

  this.dropdownEl.innerHTML = "";
  this.dropdownEl.classList.remove("show");
  this.config.onClick(itemDetails);
  if(this.searchTimer){
    clearTimeout(this.searchTimer);
  }
};
